var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isNavbarMobile)?_c('SdsMobileHeader',{attrs:{"isBeingLoaded":_vm.isBeingLoaded}}):_c('SdsGlobalHeader',{attrs:{"isBeingLoaded":_vm.isBeingLoaded},on:{"pageClick":_vm.onPageClick}})}
var staticRenderFns = []

export { render, staticRenderFns }